import { render, staticRenderFns } from "./CMSSidebar.vue?vue&type=template&id=705ebe6f&"
import script from "./CMSSidebar.vue?vue&type=script&lang=js&"
export * from "./CMSSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports